/** @jsx jsx */
import { jsx } from '@emotion/react'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { PictureCardElement } from '../components/PictureCard'
import HTMLParsedElement from './HTMLParsedElement'

export class PictureCard extends HTMLParsedElement {
  parsedCallback() {
    const mountPoint = document.createElement('div')
    this.attachShadow({ mode: 'open' }).appendChild(mountPoint)

    const pos = this.getAttribute('pos') ?? "right";
    const image = this.getAttribute('image') ?? "";
    for(let i=0; i<this.children.length; i++) {
      const child = this.children[i];
      child.setAttribute('slot', `picturecard`);
      }
    createRoot(mountPoint).render(<PictureCardElement pos={pos} image={image} styleRoot={mountPoint} />);
  }
}
customElements.define('picture-card', PictureCard)
